var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanApplyColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7778 23.2222H1C1 24.2035 1.79644 24.9999 2.77778 24.9999H25C25.9822 24.9999 26.7778 24.2035 26.7778 23.2222H17H10.7778Z",
    fill: "#BFBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 21.8889V7.22226C25.0001 6.73071 24.6027 6.33337 24.1112 6.33337H3.66672C3.17517 6.33337 2.77783 6.73071 2.77783 7.22226V21.8889H25.0001Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6737 7.66663H4.11816V21.8888H23.6737V7.66663Z",
    fill: "#00DCF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8777 10.7778C24.5777 10.7778 26.7665 8.58895 26.7665 5.88889C26.7665 3.18883 24.5777 1 21.8777 1C19.1776 1 16.9888 3.18883 16.9888 5.88889C16.9888 8.58895 19.1776 10.7778 21.8777 10.7778Z",
    fill: "#FCB701"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34033 17.8889C6.431 18.0098 7.13678 18.7778 8.11811 18.7778C9.09944 18.7778 9.89589 18.0302 9.89589 17C9.89589 15.8027 8.54389 15.3573 8.11811 15.2222C7.69233 15.0871 6.78478 14.6249 6.78478 13.8889C6.78478 13.1529 7.38211 12.5555 8.11811 12.5555C8.59544 12.5555 9.18211 12.8027 9.45144 13.0062",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11816 19.6667V18.7778",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11816 12.5555V11.6666",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2223 6.33337H3.66672C3.17517 6.33337 2.77783 6.73071 2.77783 7.22226V21.4445",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0068 21.4444V12.1111",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7366 5.20089C26.7677 5.42578 26.7846 5.65511 26.7846 5.88889C26.7846 8.58844 24.5953 10.7778 21.8957 10.7778C19.1962 10.7778 17.0068 8.58844 17.0068 5.88889C17.0068 3.18933 19.1962 1 21.8957 1C22.9037 1 23.8406 1.30578 24.6184 1.82844",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7845 2.48181L22.044 7.22226L19.6733 4.85159",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 14.3334H20.5625",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0069 17.8889H12.5625",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 16.1111H12.5625",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7846 23.2222H1.00684C1.00684 24.2035 1.80328 24.9999 2.78461 24.9999H25.0068C25.9882 24.9999 26.7846 24.2035 26.7846 23.2222H17.0068",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanApplyColor);
export default __webpack_public_path__ + "static/media/loan-apply-color.3c102af4bbfcf6d0f8838be0fa90df7b.svg";
export { ForwardRef as ReactComponent };